<div class='or-floorplan-heatmap or-floorplan-heatmap-zoom-transition' [ngStyle]='style'></div>
